const columns = [
  {
    field: 'user_ad_id',
    headerName: 'User Id',
    minWidth: 270,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'credential',
    headerName: 'Credential',
    width: 140,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    width: 220,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'first_name',
    headerName: 'First Name',
    width: 220,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'user_status',
    headerName: 'Status',
    disableColumnMenu: true,
    width: 140,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    valueGetter: (params) => {
      if (params.row.user_status) {
        return 'Active'
      } else return 'Inactive'
    },
  },
  {
    field: 'user_roles',
    headerName: 'Group',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      return params.row.user_roles
    },
  },
]

export default columns
